import HotelsNearPOIsInLocationCards from './HotelsNearPOIsInLocationCards';

export default HotelsNearPOIsInLocationCards;
